module.exports = __webpack_public_path__ + "media/images/icons/outlined/code-1aebaf02744d08c7847f16a0ab4f8e94.svg";